import { styled } from "@mui/material";
import { colorNames } from "../Theme/Colors";
const colors = colorNames();

export const FeeCollectionWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        padding: 0 15px;
        display: flex;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }
    }

    .tab_sec {
        position: relative;
        margin-top: 25px;
        width: 100%;
        padding: 0 15px;

        .tab_inner {
            position: relative;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${colors.themeColor};

            .swiper {
                position: relative;
                width: 100%;
                height: 100%;

                .swiper-slide {
                    position: relative;
                    width: max-content !important;
                }
            }

            li {
                position: relative;
                list-style: none;
                height: 100%;
                padding: 0 20px;
                padding-top: 2px;
                display: flex;
                align-items: center;
                font-size: 12.5px;
                color: ${colors.customColors.blackColor1};
                border-radius: 6px 6px 0 0;
                cursor: pointer;
                transition: all 0.5s ease;
                
                &:hover {
                    color: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
                
                &.active {
                    color: ${colors.customColors.whiteColor};
                    background: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .class_levels {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        
        .class_level_box {
            position: relative;
            width: 100%;
            margin-top: 16px;
            padding-bottom: 25px;
            display: flex;
            flex-direction: column;

            &::before {
                content: '';
                position: absolute;
                left: 15px;
                bottom: 0;
                width: calc(100% - 30px);
                height: 1px;
                background: linear-gradient(to right, ${colors.customColors.borderColor} 70%, transparent);
            }

            &:last-of-type {
                &::before {
                    display: none;
                }
            }

            .box_head {
                position: relative;
                width: 100%;
                padding: 0 20px;

                span {
                    position: relative;
                    font-size: 14px;
                    font-weight: 500;
                    color: ${colors.customColors.blackColor1};
                    font-style: italic;
                }
            }

            .box_items {
                position: relative;
                width: 100%;
                padding: 0 15px;
                display: flex;
                flex-direction: column;

                .class_item {
                    position: relative;
                    margin-top: 15px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid ${colors.customColors.borderColor};
                    border-radius: 8px;
                    box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2};
                    overflow: hidden;
                    transition: border-color 0.35s ease, box-shadow 0.35s ease;

                    .top_part {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        padding: 10px 16px;
                        cursor: pointer;
                        border-radius: 8px;
                        transition: background-color 0.35s ease, border-radius 0.35s ease;

                        &.active {
                            background: ${colors.customColors.lightBackground1};
                            border-radius: 8px 8px 0 0;
                        }

                        &:focus-visible {
                            outline: 2px solid ${colors.themeColor};
                            outline-offset: -2px;
                        }

                        .left_info {
                            position: relative;

                            li {
                                position: relative;
                                list-style: none;
                                display: flex;
                                align-items: center;

                                p {
                                    position: relative;
                                    width: 35px;
                                    height: 35px;
                                    border-radius: 4px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background: ${colors.customColors.blueColorLight};
                                    font-size: 13px;
                                    color: ${colors.customColors.blueColor1};
                                    margin-right: 7px;
                                }

                                span {
                                    position: relative;
                                    margin-top: 1px;
                                    font-size: 15px;
                                    color: ${colors.customColors.blackColor};
                                    font-weight: 600;
                                }
                            }
                        }

                        .right_info {
                            position: relative;
                            margin-left: auto;
                            display: flex;

                            li {
                                position: relative;
                                list-style: none;
                                display: flex;
                                flex-direction: column;
                                padding: 0 14px;

                                &::before {
                                    content: '';
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 1px;
                                    height: 100%;
                                    background: linear-gradient(to bottom, transparent, ${colors.customColors.borderColor1}, transparent);
                                }

                                &:last-of-type {
                                    padding-right: 0;

                                    &::before {
                                        display: none;
                                    }
                                }

                                p {
                                    position: relative;
                                    font-size: 10px;
                                    color: ${colors.customColors.blackColor2};
                                    font-style: italic;

                                    label {
                                        position: relative;
                                        margin-left: 3px;
                                        z-index: 5;

                                        i {
                                            font-size: 9px;
                                            cursor: pointer;
                                        }

                                        a {
                                            position: absolute;
                                            right: -10px;
                                            top: -42px;
                                            width: 135px;
                                            padding: 7px 10px;
                                            background: ${colors.customColors.whiteColor};
                                            box-shadow: 0 0 5px ${colors.boxShadowColors.shadowColor1};
                                            border-radius: 5px;
                                            font-size: 9px;
                                            pointer-events: none;
                                            opacity: 0;
                                            visibility: hidden;
                                            transition: all 0.5s ease;

                                            &::after {
                                                content: '';
                                                position: absolute;
                                                bottom: -4px;
                                                right: 10.5px;
                                                width: 8px;
                                                height: 8px;
                                                background: ${colors.customColors.whiteColor};
                                                transform: rotate(45deg);
                                                box-shadow: 4px 4px 5px ${colors.boxShadowColors.shadowColor1};
                                            }
                                        }

                                        &:hover {
                                            a {
                                                opacity: 1;
                                                visibility: visible;
                                                transition: all 0.5s ease;
                                            }
                                        }
                                    }
                                }

                                span {
                                    position: relative;
                                    font-size: 14px;
                                    font-weight: 500;

                                    b {
                                        font-weight: 500;
                                        font-size: 11px;
                                        margin-right: 1px;
                                    }

                                    &.applied {
                                        color: ${colors.customColors.blueColor2};
                                    }

                                    &.discount {
                                        color: ${colors.customColors.yellowColor1};
                                    }

                                    &.paid {
                                        color: ${colors.customColors.greenColor};
                                    }

                                    &.due {
                                        color: ${colors.customColors.redColor};
                                    }
                                }
                            }
                        }

                        .icon {
                            position: relative;
                            margin-left: 40px;
                            width: 35px;
                            height: 35px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            box-shadow: 0 0 5px ${colors.boxShadowColors.shadowColor1};
                            transition: background-color 0.35s ease, transform 0.35s ease;

                            i {
                                position: relative;
                                font-size: 14px;
                                color: ${colors.customColors.blackColor2};
                                transition: transform 0.35s ease, color 0.35s ease;
                            }
                        }

                        &.active .icon {
                            i {
                                transform: rotate(90deg);
                            }
                        }
                    }

                    .bottom_part {
                        position: relative;
                        width: 100%;
                        display: grid;
                        grid-template-rows: 0fr;
                        opacity: 0;
                        visibility: hidden;
                        transition: grid-template-rows 0.45s ease, opacity 0.3s ease, visibility 0s linear 0.45s;

                        &.active {
                            grid-template-rows: 1fr;
                            opacity: 1;
                            visibility: visible;
                            transition: grid-template-rows 0.45s ease, opacity 0.35s ease 0.08s, visibility 0s linear;

                            .bottom_inner {
                                padding-top: 15px;
                                padding-bottom: 15px;
                            }
                        }

                        .bottom_inner {
                            position: relative;
                            width: 100%;
                            min-height: 0;
                            overflow: hidden;
                            padding: 0 15px;
                            display: flex;
                            flex-direction: column;
                            transition: padding 0.45s ease;

                            .filter_search_sec {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: center;

                                .search_sec {
                                    position: relative;
                                    height: 35px;
                                    padding: 5px 0;
                                    display: flex;
                                    border: 1px solid ${colors.customColors.borderColor};
                                    border-radius: 6px;

                                    i {
                                        position: relative;
                                        width: 40px;
                                        height: 100%;
                                        font-size: 13px;
                                        color: ${colors.customColors.blackColor3};
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border-right: 1px solid ${colors.customColors.borderColor};
                                    }

                                    input {
                                        position: relative;
                                        width: 300px;
                                        height: 100%;
                                        border: none;
                                        outline: none;
                                        padding: 0 15px;
                                        font-size: 12px;
                                        color: ${colors.customColors.blackColor1};
                                    }
                                }

                                .filter_sec {
                                    position: relative;
                                    margin-left: auto;
                                    display: flex;
                                    align-items: center;

                                    h6 {
                                        position: relative;
                                        font-size: 12px;
                                        color: ${colors.customColors.blackColor1};
                                        margin-right: 6px;
                                        font-weight: 400;
                                    }

                                    .filter_btn {
                                        position: relative;
                                        width: 200px;
                                        height: 35px;
                                        border: 1px solid ${colors.customColors.borderColor};
                                        border-radius: 6px;
                                        display: flex;
                                        align-items: center;
                                        padding: 5px 15px;
                                        cursor: pointer;

                                        p {
                                            position: relative;
                                            font-size: 12px;
                                            color: ${colors.customColors.blackColor1};
                                        }

                                        i {
                                            position: relative;
                                            margin-left: auto;
                                            color: ${colors.customColors.blackColor1};
                                            font-size: 13px;
                                        }
                                    }
                                }
                            }

                            .table_sec {
                                position: relative;
                                width: 100%;
                                margin-top: 15px;

                                table {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-direction: column;

                                    thead {
                                        position: relative;
                                        width: 100%;
                                        height: 40px;
                                        background: ${colors.themeColor};
                                        border-radius: 10px 10px 0px 0px;
                                        border: 1px solid ${colors.themeColor};

                                        tr {
                                            position: relative;
                                            width: 100%;
                                            height: 100%;
                                            display: flex;
                                        }

                                        th {
                                            position: relative;
                                            height: 100%;
                                            display: flex;
                                            align-items: center;
                                            font-family: "Lemonada", cursive;
                                            font-size: 12px;
                                            word-break: break-all;
                                            color: ${colors.customColors.whiteColor};
                                            padding: 0 25px;
                                            font-weight: 600;

                                            &:nth-of-type(1) {
                                                width: 25%;
                                            }
                                            &:nth-of-type(2) {
                                                width: 20%;
                                                justify-content: center;
                                            }
                                            &:nth-of-type(3) {
                                                width: 18%;
                                                justify-content: center;
                                            }
                                            &:nth-of-type(4) {
                                                width: 18%;
                                                justify-content: center;
                                            }
                                            &:nth-of-type(5) {
                                                width: 19%;
                                                justify-content: center;
                                            }
                                        }
                                    }

                                    tbody {
                                        position: relative;
                                        width: 100%;
                                        border: 1px solid ${colors.customColors.whiteColor2};
                                        border-top: none;
                                        border-radius: 0px 0px 10px 10px;
                                        display: flex;
                                        flex-direction: column;
                                        overflow: hidden;

                                        tr {
                                            position: relative;
                                            width: 100%;
                                            min-height: 40px;
                                            display: flex;

                                            &:nth-of-type(even) {
                                                background: ${colors.customColors.blueColorLight};
                                            }

                                            td {
                                                position: relative;
                                                padding: 12px 25px;
                                                display: flex;
                                                color: ${colors.customColors.blackColor};
                                                font-size: 13px;
                                                word-break: break-all;
                                                line-height: 1.5;

                                                &:nth-of-type(1) {
                                                    width: 25%;
                                                    display: flex;

                                                    .left_table_sec {
                                                        position: relative;
                                                        width: 30px;
                                                        height: 30px;
                                                        border-radius: 6px;
                                                        display: flex;
                                                        align-items: center;
                                                        justify-content: center;
                                                        background: ${colors.customColors.blueColor2};

                                                        h5 {
                                                            position: relative;
                                                            font-size: 14px;
                                                            font-weight: 500;
                                                            color: ${colors.customColors.whiteColor};
                                                            text-transform: uppercase;
                                                        }
                                                    }

                                                    .right_table_sec {
                                                        position: relative;
                                                        width: calc(100% - 30px);
                                                        padding-left: 10px;
                                                        display: flex;
                                                        flex-direction: column;

                                                        h6 {
                                                            font-size: 13px;
                                                            font-weight: 400;
                                                            color: ${colors.customColors.blackColor1};
                                                        }

                                                        p {
                                                            font-size: 10px;
                                                            font-weight: 400;
                                                            color: ${colors.customColors.blackColor2};
                                                            /* margin-top: 3px; */
                                                        }
                                                    }
                                                }

                                                &:nth-of-type(2) {
                                                    width: 20%;
                                                    align-items: center;
                                                    justify-content: center;
                                                }

                                                &:nth-of-type(3) {
                                                    width: 18%;
                                                    align-items: center;
                                                    justify-content: center;

                                                    p {
                                                        font-size: 15px;
                                                        font-weight: 500;
                                                        color: ${colors.customColors.greenColor};

                                                        b {
                                                            font-weight: 500;
                                                            font-size: 12px;
                                                        }
                                                    }
                                                }

                                                &:nth-of-type(4) {
                                                    width: 18%;
                                                    align-items: center;
                                                    justify-content: center;

                                                    p {
                                                        font-size: 15px;
                                                        font-weight: 500;
                                                        color: ${colors.customColors.redColor};

                                                        b {
                                                            font-weight: 500;
                                                            font-size: 12px;
                                                        }
                                                    }
                                                }

                                                &:nth-of-type(5) {
                                                    width: 19%;
                                                    align-items: center;
                                                    justify-content: center;

                                                    a.collect_btn {
                                                        position: relative;
                                                        padding: 6px 15px;
                                                        background: ${colors.customColors.blueColor1};
                                                        font-size: 12px;
                                                        font-weight: 500;
                                                        color: ${colors.customColors.whiteColor};
                                                        border-radius: 5px;
                                                        cursor: pointer;
                                                    }
                                                }

                                                &.student_empty_message {
                                                    width: 100%;
                                                    min-height: 80px;
                                                    align-items: center;
                                                    justify-content: center;
                                                    color: ${colors.customColors.blackColor2};
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .empty_messege {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        margin-top: 100px;

        img {
            position: relative;
            width: 300px;
            opacity: 0.5;
        }

        p {
            position: relative;
            font-size: 15px;
            margin-top: 10px;
            color: ${colors.customColors.blackColor3};
        }
    }
`;

export const FeeTransactionsWrapper = styled('div')`
    position: relative;
    width: 100%;
    padding: 0 15px;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }
    }

    .fee_search_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 20px;

        .search_sec {
            position: relative;
            height: 35px;
            padding: 5px 0;
            display: flex;
            border: 1px solid ${colors.customColors.borderColor};
            border-radius: 6px;

            i {
                position: relative;
                width: 40px;
                height: 100%;
                font-size: 13px;
                color: ${colors.customColors.blackColor3};
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid ${colors.customColors.borderColor};
            }

            input {
                position: relative;
                width: 300px;
                height: 100%;
                border: none;
                outline: none;
                padding: 0 15px;
                font-size: 12px;
                color: ${colors.customColors.blackColor1};
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 16%;
                    }

                    &:nth-of-type(2) {
                        width: 11%;
                        justify-content: center;
                    }

                    &:nth-of-type(3) {
                        width: 12%;
                        justify-content: center;
                    }

                    &:nth-of-type(4) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(5) {
                        width: 10%;
                        justify-content: center;
                    }
                    &:nth-of-type(6) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(7) {
                        width: 12%;
                        justify-content: center;
                    }

                    &:nth-of-type(8) {
                        width: 9%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 16%;
                            display: flex;

                            .left_table_sec {
                                position: relative;
                                width: 30px;
                                height: 30px;
                                border-radius: 6px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: ${colors.customColors.blueColor2};

                                h5 {
                                    position: relative;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: ${colors.customColors.whiteColor};
                                    text-transform: uppercase;
                                }
                            }

                            .right_table_sec {
                                position: relative;
                                width: calc(100% - 30px);
                                padding-left: 10px;
                                display: flex;
                                flex-direction: column;

                                h6 {
                                    font-size: 13px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blackColor1};
                                }

                                p {
                                    font-size: 11px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blackColor2};
                                }
                            }
                        }

                        &:nth-of-type(2) {
                            width: 11%;
                            justify-content: center;
                            align-items: center;
                        }

                        &:nth-of-type(3) {
                            width: 12%;
                            justify-content: center;
                            align-items: center;
                        }

                        &:nth-of-type(4) {
                            width: 15%;
                            justify-content: center;
                            align-items: center;
                        }

                        &:nth-of-type(5) {
                            width: 10%;
                            justify-content: center;
                            align-items: center;
                        }

                        &:nth-of-type(6) {
                            width: 15%;
                            justify-content: center;
                            align-items: center;
                        }

                        &:nth-of-type(7) {
                            width: 12%;
                            justify-content: center;
                            align-items: center;

                            p {
                                position: relative;
                                font-size: 10px;
                                font-weight: 500;
                                line-height: 1;
                                display: flex;
                                align-items: center;
                                border-radius: 20px;
                                padding: 4px 15px;
                                color: ${colors.customColors.redColor};
                                background: ${colors.customColors.redColorLight};

                                &.success {
                                    color: ${colors.customColors.greenColor};
                                    background: ${colors.customColors.greenColorLight};
                                }
                            }
                        }

                        &:nth-of-type(8) {
                            width: 9%;
                            justify-content: center;
                            align-items: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.download {
                                    color: ${colors.customColors.blueColor1};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const FeeConfigurationWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .heading_part {
        position: relative;
        width: 100%;
        padding: 0 15px;
        display: flex;

        .inner_part {
            position: relative;
            width: max-content;
            padding: 6px;
            background: ${colors.customColors.lightBackground};
            border-radius: 6px;
            display: flex;

            .part_box {
                position: relative;
                padding: 8px 20px;
                cursor: pointer;
                border-radius: 4px;
                text-decoration: none;
                
                &.active {
                    background: ${colors.customColors.blueColor1};
                }

                h6 {
                    position: relative;
                    font-size: 13px;
                    font-weight: 500;
                    color: ${colors.customColors.blackColor1};
                }
                
                &.active h6 {
                    color: ${colors.customColors.whiteColor};
                }
            }
        }
    }
`;

export const FeesStructureWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    
    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        margin-top: 20px;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .btns_sec {
            position: relative;
            margin-left: auto;
            display: flex;
            align-items: center;

            button {
                position: relative;
                width: max-content;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                padding: 0 25px;
                font-size: 12.5px;
                cursor: pointer;

                &.feeType {
                    background: ${colors.customColors.whiteColor};
                    border: 2px solid ${colors.customColors.blueColor2};
                    color: ${colors.customColors.blueColor2};
                    border-radius: 6px;
                }
                
                &.addStructure {
                    margin-left: 20px;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-weight: 500;
                }

                i {
                    font-size: 12px;
                    margin-right: 5px;
                }
            }
        }
    }

    .tab_sec {
        position: relative;
        margin-top: 15px;
        width: 100%;
        padding: 0 15px;

        .tab_inner {
            position: relative;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${colors.themeColor};

            li {
                position: relative;
                list-style: none;
                height: 100%;
                padding: 0 20px;
                padding-top: 2px;
                display: flex;
                align-items: center;
                font-size: 12.5px;
                color: ${colors.customColors.blackColor1};
                border-radius: 6px 6px 0 0;
                cursor: pointer;
                transition: all 0.5s ease;
                
                &:hover {
                    color: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
                
                &.active {
                    color: ${colors.customColors.whiteColor};
                    background: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .fees_structure_levels {
        position: relative;
        width: 100%;
        padding: 0 5px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;

        .level_box {
            position: relative;
            width: 25%;
            max-width: 302.75px;
            padding: 10px;

            .box_inner {
                position: relative;
                width: 100%;
                padding: 12px;
                padding-left: 15px;
                background: ${colors.customColors.whiteColor};
                border: 1px solid ${colors.customColors.borderColor};
                border-left: 4px solid ${colors.customColors.greenColor};
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                .top_part {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 8px;
                    border-bottom: 1px solid ${colors.customColors.borderColor};

                    .part_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        
                        a {
                            position: relative;
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: ${colors.customColors.greenColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            color: ${colors.customColors.greenColor};
                            text-decoration: none;
                            cursor: pointer;
                        }
                        
                        h6 {
                            position: relative;
                            padding-left: 5px;
                            max-width: calc(100% - 85px);
                            font-size: 13.5px;
                            font-style: italic;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor};
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        span {
                            position: relative;
                            width: max-content;
                            display: flex;
                            font-size: 10px;
                            color: ${colors.customColors.orangeColor};
                            margin-top: 2px;
                            background: ${colors.customColors.yellowColorLight};
                            border-radius: 25px;
                            padding: 3px 15px;
                            margin-left: auto;
                            font-weight: 500;
                        }
                    }

                    .class_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: flex-end;
                        font-size: 12px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor};
                        text-decoration: none;
                        margin-top: 6px;

                        span {
                            margin-left: 4px;
                            color: ${colors.customColors.blackColor2};
                            font-size: 11px;
                        }
                    }

                    .fees_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        margin-top: 5px;

                        h6 {
                            position: relative;
                            font-size: 11px;
                            font-weight: 400;
                            font-style: italic;
                            color: ${colors.customColors.blackColor};
                        }

                        .installments_sec {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            
                            li {
                                position: relative;
                                width: 49%;
                                list-style: none;
                                display: flex;
                                align-items: center;
                                font-size: 10px;
                                color: ${colors.customColors.blackColor};
                                margin-top: 2px;

                                span {
                                    margin-left: 5px;
                                    font-size: 11px;
                                }
                            }
                        }
                    }

                    p {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        font-size: 10px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor1};
                        margin-top: 8px;

                        &.receipt_prefix {
                            margin-top: 3px;
                        }

                        span {
                            color: ${colors.customColors.blackColor2};
                            margin-left: 5px;
                        }
                    }
                }

                .bottom_btn {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: flex-end;
                    margin-top: 8px;

                    .total_sec {
                        position: relative;
                        width: max-content;
                        display: flex;
                        align-items: center;

                        h5 {
                            position: relative;
                            font-size: 13px;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor};
                            
                            span {
                                color: ${colors.customColors.blackColor};
                                margin-left: 2px;
                            }
                        }
                    }

                    .btns_sec {
                        position: relative;
                        margin-left: auto;
                        display: flex;

                        button {
                            position: relative;
                            width: max-content;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: none;
                            padding: 0 10px;

                            i {
                                margin-right: 5px;
                            }

                            &.delete {
                                background: ${colors.customColors.redColorLight};
                                color:  ${colors.customColors.redColor};
                                font-size: 10px;
                                cursor: pointer;
                                border-radius: 4px;
                            }
                        }
                    }
                }
            }
        }

        .empty_box {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            margin-top: 50px;

            img {
                position: relative;
                width: 300px;
                opacity: 0.5;
            }

            p {
                position: relative;
                font-size: 15px;
                margin-top: 10px;
                color: ${colors.customColors.blackColor3};
            }
        }
    }
`;

export const DiscountWrapper = styled('div')`
    width: 100%;
    .special_discounts_row {
        display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 15px; padding: 20px 15px 16px;
        .staff_discount_section { padding: 0; min-width: 0; }
        .box_inner.staff_discount_card { max-width: none; height: 100%; }
        .staff_discount_card > .card_heading { flex-wrap: wrap; }
        .staff_heading_text { flex-basis: 130px; }
        .staff_discount_toggle { margin-left: auto; }
        .special_discount_footer { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding-top: 10px; font-size: 11px; color: ${colors.customColors.blackColor2}; }
        @media (max-width: 700px) { grid-template-columns: 1fr; }
    }
    .staff_discount_section { padding: 20px 15px 16px; }
    .box_inner.staff_discount_card {
        max-width: 640px; min-height: 0; height: auto; padding: 0;
        border: 1px solid #dfe6e2; border-radius: 10px;
        box-shadow: 0 2px 6px rgba(24, 49, 35, 0.035);
        > .card_heading { padding: 16px 18px; gap: 12px; align-items: flex-start; }
        .discount_icon { width: 42px; height: 42px; border-radius: 10px; background: #edf5ef; color: #34714c; font-size: 14px}
        .staff_heading_text { flex: 1; min-width: 0; }
        .staff_eyebrow { display: block; margin-bottom: 1px; font-size: 8px; font-weight: 600; letter-spacing: 1px; color: #63816d; }
        h6 { font-size: 13px; font-weight: 600; font-style: normal; line-height: 1.4; white-space: normal; }
        .staff_heading_text p { font-size: 10px; line-height: 1.5; color: #7a827e; margin-top: 2px; }
        .staff_configuration { padding: 14px 18px 0; border-top: 1px solid #e8ede9; background: #fbfcfb; border-radius: 0 0 10px 10px; }
        .staff_configuration_heading { display: flex; justify-content: space-between; align-items: center; gap: 10px; font-size: 11px; font-weight: 600; color: #36473d; }
        .staff_draft_badge { font-size: 9px; font-weight: 400; color: #7a827e; }
        .offer { margin: 14px 0 0; padding: 9px 12px; background: #f0f6f2; }
        .staff_configuration_footer { display: flex; align-items: center; gap: 6px; margin-top: 14px; padding: 10px 0; border-top: 1px solid #e8ede9; font-size: 9px; color: #87908a; }
        @media (max-width: 480px) {
            > .card_heading { flex-wrap: wrap; padding: 13px; }
            .staff_discount_toggle { margin-left: auto; }
            .staff_configuration { padding: 12px 13px 0; }
        }
    }
    .staff_discount_description { margin: 8px 0 0; font-size: 11px; line-height: 1.5; color: ${colors.customColors.blackColor2}; }
    .regular_discounts_title { margin: 0 15px; padding-top: 12px; border-top: 1px solid ${colors.customColors.borderColor}; font-size: 16px; font-weight: 600; color: ${colors.customColors.blackColor}; font-family: "SUSE", sans-serif;}
    .staff_discount_toggle {
        position: relative; display: flex; align-items: center; gap: 7px; cursor: pointer;
        font-size: 10px; color: ${colors.customColors.blackColor2}; flex-shrink: 0;
        input { position: absolute; right: 0; width: 32px; height: 18px; opacity: 0; cursor: pointer; }
        .toggle_track { width: 32px; height: 18px; border-radius: 12px; background: #cbd2ce; transition: background 0.2s; pointer-events: none; }
        .toggle_track::after { content: ''; display: block; width: 14px; height: 14px; margin: 2px; border-radius: 50%; background: white; box-shadow: 0 1px 3px #0002; transition: transform 0.2s; }
        input:checked + .toggle_track { background: #287344; }
        input:checked + .toggle_track::after { transform: translateX(14px); }
        input:focus-visible + .toggle_track { outline: 2px solid #287344; outline-offset: 3px; }
    }
    .discount_boxes {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(min(100%, 270px), 1fr));
        gap: 18px;
        padding: 20px 15px;
    }
    .discount_box { min-width: 0; }
    .box_inner {
        height: 100%;
        min-height: 145px;
        display: flex;
        flex-direction: column;
        background: ${colors.customColors.whiteColor};
        border: 1px solid ${colors.customColors.borderColor};
        border-left: 4px solid ${colors.customColors.greenColor};
        border-radius: 8px;
        padding: 12px 12px 10px 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.045);
        transition: box-shadow 0.2s ease;
        &:hover { box-shadow: 0 6px 20px rgba(0, 0, 0, 0.075); }
    }
    .card_heading { display: flex; align-items: center; gap: 9px; }
    .discount_icon {
        width: 32px; height: 32px; flex-shrink: 0;
        display: flex; align-items: center; justify-content: center;
        border-radius: 50%; font-size: 12px;
        background: ${colors.customColors.greenColorLight};
        color: ${colors.customColors.greenColor};
    }
    h6 {
        flex: 1; min-width: 0; font-size: 13.5px; font-weight: 500; font-style: italic;
        overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        color: ${colors.customColors.blackColor};
    }
    .offer {
        display: flex; align-items: stretch; gap: 12px;
        margin: 12px 0 10px;
        padding: 8px 12px 7px 12px;
        border: 1px solid #e8ecea;
        border-radius: 7px;
        background: linear-gradient(110deg, #f3f8f5, #fafcfb);
        color: ${colors.customColors.blackColor1};
        .offer_value { flex: 1; min-width: 0; }
        .offer_label {
            display: block; margin-bottom: 2px;
            font-size: 9px; line-height: 1.3; font-weight: 500;
            letter-spacing: 0.2px; color: #69766e;
        }
        p { margin: 0; font-size: 11px; line-height: 1.3; overflow-wrap: anywhere; }
        strong { font-size: 16px; font-weight: 600; color: #23643e; font-variant-numeric: tabular-nums; }
        .offer_suffix { font-size: 10px; color: #69766e; }
        .offer_limit {
            flex: 1; min-width: 0;
            margin-left: auto;
            padding-left: 12px;
            border-left: 1px solid #dde6e0;
            text-align: right;
            strong { font-size: 13px; font-weight: 600; color: #35443b; }
            .limit_prefix { font-size: 10px; color: #69766e; }
        }
    }
    .card_footer {
        display: flex; align-items: center; justify-content: space-between; gap: 10px;
        margin-top: auto; padding-top: 8px; border-top: 1px solid ${colors.customColors.borderColor};
    }
    .fee_sec { display: flex; flex: 1; flex-wrap: wrap; gap: 2px 4px; min-width: 0; }
    .fee_label { font-size: 12px; color: ${colors.customColors.blackColor}; }
    .fee_name { font-size: 12px; overflow-wrap: anywhere; color: ${colors.customColors.blackColor2}; }
    .btns_sec {
        display: flex; flex-shrink: 0;
        button {
            display: flex; align-items: center; justify-content: center; gap: 5px;
            height: 27px; padding: 0 10px; border: none; border-radius: 0;
            font-size: 11px; font-weight: 500; cursor: pointer;
            &:focus-visible { outline: 2px solid ${colors.customColors.blueColor2}; outline-offset: 2px; }
        }
        .edit { border-radius: 4px 0 0 4px; background: ${colors.customColors.blueColorLight}; color: ${colors.customColors.blueColor2}; }
        .delete { border-radius: 0 4px 4px 0; background: ${colors.customColors.redColorLight}; color: ${colors.customColors.redColor}; }
    }
    .empty_box {
        grid-column: 1 / -1; display: flex; flex-direction: column; align-items: center; padding: 40px 10px;
        img { width: 220px; max-width: 100%; opacity: 0.5; }
        p { margin-top: 12px; font-size: 12px; color: ${colors.customColors.blackColor3}; }
    }
`;

export const FineWrapper = styled('div')`
    position: relative;
`;

export const BankAccountsWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        margin-top: 10px;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .add_btn {
            position: relative;
            margin-left: auto;

            button {
                position: relative;
                height: 35px;
                padding: 0 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                border: none;
                color: ${colors.customColors.whiteColor};
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.5s ease;

                i {
                    margin-right: 8px;
                    font-size: 12px;
                }

                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .tab_sec {
        position: relative;
        margin-top: 25px;
        width: 100%;
        padding: 0 15px;

        .tab_inner {
            position: relative;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${colors.themeColor};

            li {
                position: relative;
                list-style: none;
                height: 100%;
                padding: 0 20px;
                padding-top: 2px;
                display: flex;
                align-items: center;
                font-size: 12.5px;
                color: ${colors.customColors.blackColor1};
                border-radius: 6px 6px 0 0;
                cursor: pointer;
                transition: all 0.5s ease;
                
                &:hover {
                    color: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
                
                &.active {
                    color: ${colors.customColors.whiteColor};
                    background: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
            }
        }
    }
`;

export const AllAccountsWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 25px;
        padding: 0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 15%;
                    }

                    &:nth-of-type(2) {
                        width: 15%;
                        justify-content: center;
                    }
                    &:nth-of-type(3) {
                        width: 15%;
                        justify-content: center;
                    }
                    &:nth-of-type(4) {
                        width: 20%;
                        justify-content: center;
                    }
                    &:nth-of-type(5) {
                        width: 15%;
                        justify-content: center;
                    }

                    &:nth-of-type(6) {
                        width: 10%;
                        justify-content: center;
                    }

                    &:nth-of-type(7) {
                        width: 10%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.whiteColor2};
                border-top: none;
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        padding: 12px 25px;
                        display: flex;
                        color: ${colors.customColors.blackColor};
                        font-size: 13px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 15%;
                            display: flex;
                        }

                        &:nth-of-type(2) {
                            width: 15%;
                            align-items: center;
                            justify-content: center;
                        }
                        &:nth-of-type(3) {
                            width: 15%;
                            align-items: center;
                            justify-content: center;
                        }
                        &:nth-of-type(4) {
                            width: 20%;
                            align-items: center;
                            justify-content: center;
                        }
                        &:nth-of-type(5) {
                            width: 15%;
                            padding: 5px 25px;
                            align-items: center;
                            justify-content: center;

                            a {
                                color: ${colors.customColors.blueColor2};
                                text-decoration: none;
                                font-size: 14px;
                                cursor: pointer;
                            }
                        }

                        &:nth-of-type(6) {
                            width: 10%;
                            justify-content: center;

                            p {
                                position: relative;
                                font-size: 10px;
                                font-weight: 500;
                                line-height: 1;
                                display: flex;
                                align-items: center;
                                border-radius: 20px;
                                padding: 4px 15px;
                                color: ${colors.customColors.redColor};
                                background: ${colors.customColors.redColorLight};

                                &.active {
                                    color: ${colors.customColors.greenColor};
                                    background: ${colors.customColors.greenColorLight};
                                }
                            }
                        }

                        &:nth-of-type(7) {
                            width: 10%;
                            align-items: center;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                               &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                    margin-right: 10px;
                               }

                               &.delete_btn {
                                    color: ${colors.customColors.redColor};
                               }
                            }
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const SplitAccountsWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .bank_account_boxes {
        position: relative;
        width: 100%;
        padding: 0 5px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;

        .account_box {
            position: relative;
            width: 25%;
            max-width: 302.75px;
            padding: 10px;

            .box_inner {
                position: relative;
                width: 100%;
                padding: 12px;
                padding-left: 15px;
                background: ${colors.customColors.whiteColor};
                border: 1px solid ${colors.customColors.borderColor};
                border-left: 4px solid ${colors.customColors.greenColor};
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                .top_part {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 8px;
                    border-bottom: 1px solid ${colors.customColors.borderColor};

                    .part_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        
                        a {
                            position: relative;
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            background: ${colors.customColors.greenColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            color: ${colors.customColors.greenColor};
                            text-decoration: none;
                            cursor: pointer;
                        }

                        .content_item {
                            position: relative;
                            width: calc(100% - 32px);
                            padding-left: 10px;
                            display: flex;
                            flex-direction: column;

                            h6 {
                                position: relative;
                                width: 100%;
                                font-size: 13.5px;
                                font-style: italic;
                                font-weight: 500;
                                color: ${colors.customColors.blackColor};
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            p {
                                position: relative;
                                width: 100%;
                                display: flex;
                                font-size: 10px;
                                color: ${colors.customColors.blackColor1};
                                margin-top: 2px;
                                font-weight: 500;
                                
                                span {
                                    color: ${colors.customColors.blackColor2};
                                    margin-left: 4px;
                                }
                            }
                        }
                    }

                    .fee_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        font-size: 11px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor};
                        text-decoration: none;
                        margin-top: 10px;

                        i {
                            font-size: 10px;
                            margin-right: 3px;
                        }

                        span {
                            margin-left: 4px;
                            color: ${colors.customColors.blackColor2};
                            font-size: 11px;
                        }
                    }
                    .class_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: flex-end;
                        font-size: 11px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor};
                        text-decoration: none;
                        margin-top: 4px;

                        span {
                            margin-left: 4px;
                            color: ${colors.customColors.blackColor2};
                            font-size: 11px;
                        }
                    }
                }

                .bottom_btn {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: flex-end;
                    margin-top: 8px;

                    .btns_sec {
                        position: relative;
                        margin-left: auto;
                        display: flex;

                        button {
                            position: relative;
                            width: max-content;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: none;
                            padding: 0 10px;

                            &.edit {
                                background: ${colors.customColors.blueColorLight};
                                color: ${colors.customColors.blueColor2};
                                font-size: 10px;
                                cursor: pointer;
                                font-weight: 500;
                                border-bottom-left-radius: 4px;
                                border-top-left-radius: 4px;

                                i {
                                    margin-right: 6px;
                                }
                            }

                            &.delete {
                                background: ${colors.customColors.redColorLight};
                                color:  ${colors.customColors.redColor};
                                font-size: 10px;
                                cursor: pointer;
                                border-top-right-radius: 4px;
                                border-bottom-right-radius: 4px;
                            }
                        }
                    }
                }
            }
        }

        .empty_messege {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            margin-top: 60px;

            img {
                position: relative;
                width: 250px;
                opacity: 0.5;
            }

            p {
                position: relative;
                font-size: 13px;
                margin-top: 10px;
                color: ${colors.customColors.blackColor3};
            }
        }
    }
`;

export const AddFeesStructureWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        padding: 0 15px;
        display: flex;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }
    }

    .progress_section {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;
        margin-top: 25px;

        .sec_box {
            position: relative;
            width: 37px;
            height: 37px;
            border-radius: 50%;
            border: 1px solid ${colors.customColors.borderColor1};
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;

            p {
                position: relative;
                font-size: 13px;
                color: ${colors.customColors.blackColor2};
                transition: all 0.2s ease;
            }

            &.active {
                border: 1px solid ${colors.customColors.greenColor};
                background: ${colors.customColors.greenColor};
                transition: all 0.2s ease;
                transition-delay: 0.3s;

                p {
                    color: ${colors.customColors.whiteColor};
                    transition: all 0.2s ease;
                    transition-delay: 0.3s;
                }
            }
        }

        .line {
            position: relative;
            width: 120px;
            height: 4px;
            border-radius: 25px;
            background: ${colors.customColors.lightBackground3};
            margin: 0 10px;

            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 0;
                height: 100%;
                background: ${colors.customColors.greenColor}; 
                transition: width 0.5s ease;
            }

            &.active {
                &::after {
                    width: 100%;
                    transition: width 0.5s ease;
                } 
            }
        }
    }

    .fees_structure_level_sec {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 35px;

        .criteria_sec {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            .sec_head {
                position: relative;
                width: 100%;
                padding: 0 15px;

                span {
                    position: relative;
                    font-size: 14px;
                    font-weight: 600;
                    color: ${colors.customColors.blackColor1};
                    font-style: italic;
                }
            }

            .sec_item {
                position: relative;
                width: 100%;
                padding: 0 15px;
                display: flex;
                flex-direction: column;

                .class_item {
                    position: relative;
                    margin-top: 15px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid ${colors.customColors.borderColor};
                    border-radius: 8px;
                    box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2};

                    .top_part {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        padding: 10px 16px;
                        cursor: pointer;
                        border-radius: 8px 8px 0 0;
                        transition: all 0.5s ease;

                        &.active {
                            background: ${colors.customColors.lightBackground1};
                        }

                        .left_info {
                            position: relative;

                            input[type="checkbox"] {
                                display: none;
                            }

                            label {
                                position: relative;
                                cursor: pointer;
                                font-size: 13px;
                                color: ${colors.customColors.blackColor2};
                                line-height: 1;
                                display: flex;
                                align-items: center;

                                .check_box {
                                    position: relative;
                                    width: 18px;
                                    height: 18px;
                                    border: 1px solid ${colors.customColors.borderColor1};
                                    border-radius: 4px;
                                    cursor: pointer;
                                    transition: all 0.4s ease;

                                    img {
                                        position: absolute;
                                        left: 2px;
                                        bottom: 2px;
                                        width: 20px;
                                        opacity: 0;
                                        transition: all 0.4s ease;
                                    }
                                }

                                p {
                                    position: relative;
                                    margin-left: 10px;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor1};
                                }
                            }

                            input[type="checkbox"]:checked ~ label {
                                color: ${colors.customColors.blackColor1};
                                transition: all 0.5s ease;

                                .check_box {
                                    border: 1px solid ${colors.customColors.blackColor1};
                                    transition: all 0.4s ease;

                                    img {
                                        opacity: 1;
                                        transition: all 0.4s ease;
                                    }
                                }
                            }
                        }

                        .icon {
                            position: relative;
                            margin-left: auto;
                            width: 35px;
                            height: 35px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            box-shadow: 0 0 5px ${colors.boxShadowColors.shadowColor1};
                            cursor: pointer;

                            i {
                                position: relative;
                                font-size: 14px;
                                color: ${colors.customColors.blackColor2};
                                transition: all 0.5s ease;

                                &.active {
                                    transform: rotate(90deg);
                                    transition: all 0.5s ease;
                                }
                            }
                        }
                    }

                    .bottom_part {
                        position: relative;
                        width: 100%;
                        height: 0;
                        overflow: hidden;

                        &.active {
                            height: max-content;
                        }

                        .bottom_inner {
                            position: relative;
                            width: 100%;
                            padding: 15px;
                            display: flex;
                            justify-content: space-between;

                            .class_box {
                                position: relative;
                                width: 49.5%;
                                display: flex;
                                flex-direction: column;
                                border: 1px solid ${colors.customColors.borderColor};
                                border-radius: 8px;
                                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2};

                                .box_top {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    padding: 10px 16px;
                                    cursor: pointer;
                                    border-radius: 8px 8px 0 0;
                                    background: ${colors.customColors.lightBackground1};

                                    .top_left {
                                        position: relative;

                                        input[type="checkbox"] {
                                            display: none;
                                        }

                                        label {
                                            position: relative;
                                            cursor: pointer;
                                            font-size: 13px;
                                            color: ${colors.customColors.blackColor2};
                                            line-height: 1;
                                            display: flex;
                                            align-items: center;

                                            .check_box {
                                                position: relative;
                                                width: 18px;
                                                height: 18px;
                                                border: 1px solid ${colors.customColors.borderColor1};
                                                border-radius: 4px;
                                                cursor: pointer;
                                                transition: all 0.4s ease;

                                                img {
                                                    position: absolute;
                                                    left: 2px;
                                                    bottom: 2px;
                                                    width: 20px;
                                                    opacity: 0;
                                                    transition: all 0.4s ease;
                                                }
                                            }

                                            p {
                                                position: relative;
                                                margin-left: 10px;
                                                font-weight: 500;
                                                color: ${colors.customColors.blackColor1};
                                            }
                                        }

                                        input[type="checkbox"]:checked ~ label {
                                            color: ${colors.customColors.blackColor1};
                                            transition: all 0.5s ease;

                                            .check_box {
                                                border: 1px solid ${colors.customColors.blackColor1};
                                                transition: all 0.4s ease;

                                                img {
                                                    opacity: 1;
                                                    transition: all 0.4s ease;
                                                }
                                            }
                                        }
                                    }
                                }

                                .box_bottom {
                                    position: relative;
                                    width: 100%;

                                    .bottom_inner {
                                        position: relative;
                                        width: 100%;
                                        padding: 10px;

                                        ul {
                                            position: relative;
                                            width: 100%;
                                            display: flex;
                                            flex-wrap: wrap;
                                            max-height: 100px;
                                            overflow-y: auto;
                                            scrollbar-width: none;
                                            -ms-overflow-style: none;

                                            li {
                                                position: relative;
                                                list-style: none;
                                                margin: 5px;

                                                input[type="checkbox"] {
                                                    display: none;
                                                }

                                                label {
                                                    position: relative;
                                                    padding: 7px 20px;
                                                    padding-left: 10px;
                                                    cursor: pointer;
                                                    border-radius: 4px;
                                                    border: 1px solid ${colors.customColors.borderColor};
                                                    font-size: 12px;
                                                    color: ${colors.customColors.blackColor2};
                                                    line-height: 1;
                                                    display: flex;
                                                    align-items: center;
                                                    transition: all 0.5s ease;

                                                    .check_box {
                                                        position: relative;
                                                        width: 15px;
                                                        height: 15px;
                                                        border: 1px solid ${colors.customColors.borderColor};
                                                        border-radius: 4px;
                                                        cursor: pointer;
                                                        transition: all 0.4s ease;

                                                        img {
                                                            position: absolute;
                                                            left: 2px;
                                                            bottom: 2px;
                                                            width: 18px;
                                                            opacity: 0;
                                                            transition: all 0.4s ease;
                                                        }
                                                    }

                                                    p {
                                                        position: relative;
                                                        margin-left: 10px;
                                                    }
                                                }

                                                input[type="checkbox"]:checked ~ label {
                                                    color: ${colors.customColors.blackColor1};
                                                    transition: all 0.5s ease;

                                                    .check_box {
                                                        border: 1px solid ${colors.customColors.blackColor1};
                                                        transition: all 0.4s ease;

                                                        img {
                                                            opacity: 1;
                                                            transition: all 0.4s ease;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btn_sec {
                position: relative;
                width: 100%;
                margin-top: 50px;
                padding: 0 15px;
                display: flex;
                justify-content: flex-end;

                button {
                    position: relative;
                    width: 150px;
                    height: 35px;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    color: ${colors.customColors.whiteColor};
                    background: ${colors.customColors.blueColor1};
                    border: none;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.5s ease;

                    i {
                        margin-left: 6px;
                    }

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }

                    &:disabled {
                        opacity: 0.4;
                        cursor: not-allowed;
                        transition: all 0.5s ease;
                    }
                }
            }
        }

        .fees_sec {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            .sec_head {
                position: relative;
                width: 100%;
                padding: 0 15px;

                span {
                    position: relative;
                    font-size: 14px;
                    font-weight: 600;
                    color: ${colors.customColors.blackColor1};
                    font-style: italic;
                }
            }

            .sec_item {
                position: relative;
                width: 100%;
                display: flex;
                margin-top: 20px;
                flex-direction: column;

                .fees_type_sec {
                    position: relative;
                    width: 100%;
                    display: flex;
                    padding: 0 15px;
                    justify-content: space-between;

                    .input_box {
                        position: relative;
                        width: 15%;
                        margin-bottom: 15px;

                        span {
                            position: relative;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 400;
                            color: ${colors.customColors.blackColor2};

                            p {
                                color: ${colors.customColors.redColor};
                                margin-left: 2px;
                            }
                        }

                        .input_wrapper  {
                            position: relative;
                            margin-top: 3px;

                            input {
                                width: 100%;
                                height: 37px;
                                font-size: 12px;
                                border-radius: 5px;
                                padding: 5px 30px 5px 15px;
                                outline: none;
                                border: none;
                                background: ${colors.customColors.lightBackground3};
                            }

                            .percent_symbol {
                                position: absolute;
                                right: 10px;
                                top: 50%;
                                transform: translateY(-50%);
                                font-size: 12px;
                                color: ${colors.customColors.blackColor2};
                                pointer-events: none;
                            }
                        }

                        &.receipt_prefix {
                            width: 27%;

                            input {
                                position: relative;
                                margin-top: 3px;
                                width: 100%;
                                height: 37px;
                                font-size: 12px;
                                border-radius: 5px;
                                padding: 5px 30px 5px 15px;
                                outline: none;
                                border: none;
                                background: ${colors.customColors.lightBackground3};
                            }
                        }
                    }

                    .select_box {
                        position: relative;
                        width: 27%;
                        margin-bottom: 8px;

                        span {
                            position: relative;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 400;
                            color: ${colors.customColors.blackColor2};

                            p {
                                color: ${colors.customColors.redColor};
                                margin-left: 2px;
                            }
                        }

                        .dropdown_sec {
                            position: relative;
                            width: 100%;
                            height: 37px;
                            flex-direction: column;
                            margin-top: 3px;

                            .dropdown_btn {
                                position: relative;
                                width: 100%;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                border-radius: 5px;
                                padding: 5px 15px;
                                cursor: pointer;
                                background: ${colors.customColors.lightBackground3};

                                p {
                                    position: relative;
                                    width: calc(100% - 25px);
                                    display: flex;
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor1};
                                }

                                i {
                                    position: relative;
                                    margin-left: auto;
                                    display: flex;
                                    justify-content: flex-end;
                                    cursor: pointer;
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor2};
                                    transition: all 0.5s ease;
                                    
                                    &.active {
                                        transform: rotate(-180deg);
                                        transition: all 0.5s ease;
                                    }
                                }
                            }

                            .dropdown {
                                position: absolute;
                                top: 100%;
                                left: 0px;
                                width: 100%;
                                z-index: 15;
                                background: ${colors.customColors.whiteColor};
                                border-radius: 5px;
                                box-shadow: 5px 8px 15px ${colors.boxShadowColors.shadowColor1};
                                max-height: 0px;
                                overflow: hidden;
                                transition: all 0.5s ease;

                                &.active {
                                    max-height: 200px;
                                    transition: all 0.5s ease;
                                }

                                .dropdown_inner {
                                    position: relative;
                                    width: 100%;
                                    padding: 10px;
                                    display: flex;
                                    flex-direction: column;

                                    ul {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        flex-direction: column;
                                        max-height: 160px;
                                        overflow-y: auto;
                                        scrollbar-width: none;
                                        -ms-overflow-style: none;

                                        &::-webkit-scrollbar {
                                            display: none;
                                        }

                                        li {
                                            position: relative;
                                            width: 100%;
                                            list-style: none;
                                            padding: 7px 15px;
                                            cursor: pointer;
                                            font-size: 12px;
                                            color: ${colors.customColors.blackColor1};
                                            border-radius: 4px;
                                            transition: all 0.5s ease;

                                            &:hover {
                                                background: ${colors.themeColor};
                                                color: ${colors.customColors.whiteColor};
                                                transition: all 0.5s ease;
                                            }

                                            &.active {
                                                background: ${colors.customColors.lightBackground};
                                                color: ${colors.customColors.blackColor};

                                                &:hover {
                                                    color: ${colors.customColors.blackColor};
                                                }
                                            }

                                            &.empty_message {
                                                color: ${colors.customColors.blackColor3};
                                                padding: 5px 10px;
                                                pointer-events: none;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .fees_date_sec {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;

                    .fees_head {
                        position: relative;
                        width: 100%;
                        display: flex;
                        padding: 0 15px;

                        p {
                            position: relative;
                            font-size: 13px;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor1};
                            font-style: italic;
                        }
                    }

                    .sec_items {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0 5px;
                        margin-top: 7px;

                        .item_box {
                            position: relative;
                            width: 20%;
                            max-width: 240px;
                            padding: 10px;

                            .box_inner {
                                position: relative;
                                width: 100%;
                                max-height: 100px;
                                padding: 12px;
                                background: ${colors.customColors.whiteColor};
                                border: 1px solid ${colors.customColors.borderColor};
                                border-radius: 8px;
                                display: flex;
                                flex-direction: column;
                                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                                .inner_top {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-direction: column;
                                    padding-bottom: 8px;
                                    border-bottom: 1px solid ${colors.customColors.borderColor};

                                    h6 {
                                        position: relative;
                                        width: 100%;
                                        font-size: 12px;
                                        font-style: italic;
                                        font-weight: 500;
                                        color: ${colors.customColors.blackColor};
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    }

                                    li {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        align-items: center;
                                        list-style: none;
                                        margin-top: 3px;

                                        p {
                                            position: relative;
                                            font-size: 10px;
                                            color: ${colors.customColors.blackColor1};
                                        }
                                        
                                        span {
                                            position: relative;
                                            font-size: 10px;
                                            color: ${colors.customColors.blackColor1};
                                            margin-left: 5px;
                                        }
                                    }
                                }

                                .inner_btn {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    margin-top: 8px;
                                    justify-content: flex-end;

                                    button {
                                        position: relative;
                                        width: max-content;
                                        height: 25px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border: none;
                                        padding: 0 12px;

                                        &.edit {
                                            background: ${colors.customColors.blueColorLight};
                                            color: ${colors.customColors.blueColor2};
                                            font-size: 9px;
                                            cursor: pointer;
                                            font-weight: 500;
                                            border-bottom-left-radius: 4px;
                                            border-top-left-radius: 4px;

                                            i {
                                                margin-right: 6px;
                                                font-size: 10px;
                                            }
                                        }

                                        &.delete {
                                            background: ${colors.customColors.redColorLight};
                                            color:  ${colors.customColors.redColor};
                                            font-size: 9px;
                                            cursor: pointer;
                                            border-top-right-radius: 4px;
                                            border-bottom-right-radius: 4px;
                                        }
                                    }
                                }
                            }
                        }

                        .add_btn {
                            position: relative;
                            width: 20%;
                            max-height: 240px;
                            display: flex;
                            align-items: center;
                            padding: 10px;

                            .btn_inner {
                                position: relative;
                                width: 100%;
                                height: 100px;
                                padding: 0 6px;
                                background: ${colors.customColors.whiteColor};
                                border: 1px solid ${colors.customColors.borderColor};
                                border-radius: 8px;
                                display: flex;
                                align-items: flex-end;
                                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};
                                cursor: pointer;

                                img {
                                    position: relative;
                                    height: 80%;
                                }

                                p {
                                    position: relative;
                                    margin: auto 0;
                                    font-size: 11px;
                                    color: ${colors.customColors.blackColor1};
                                    padding-left: 10px;
                                    line-height: 1.3;
                                }
                            }
                        }
                    }
                }
            }

            .btn_sec {
                position: relative;
                width: 100%;
                margin-top: 50px;
                padding: 0 15px;
                display: flex;
                justify-content: space-between;

                button {
                    position: relative;
                    width: 150px;
                    height: 35px;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    color: ${colors.customColors.whiteColor};
                    border: none;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.5s ease;

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }

                    &:disabled {
                        opacity: 0.4;
                        cursor: not-allowed;
                        transition: all 0.5s ease;
                    }

                    &:first-of-type {
                        background: ${colors.customColors.blackColor3};

                        i {
                            margin-right: 6px;
                        }
                    }

                    &:last-of-type {
                        background: ${colors.customColors.blueColor1};

                        i {
                            margin-left: 6px;
                        }
                    }
                }
            }
        }

        .review_sec {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            
            .sec_head {
                position: relative;
                width: 100%;
                padding: 0 15px;

                span {
                    position: relative;
                    font-size: 14px;
                    font-weight: 600;
                    color: ${colors.customColors.blackColor1};
                    font-style: italic;
                }
            }

            .sec_items {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 5px;

                .details_sec {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;

                    .brief_box {
                        position: relative;
                        width: 30%;
                        padding: 10px;

                        .box_inner {
                            position: relative;
                            width: 100%;
                            height: 100%;
                            padding: 15px;
                            background: ${colors.customColors.whiteColor};
                            border: 1px solid ${colors.customColors.borderColor};
                            border-radius: 8px;
                            display: flex;
                            flex-direction: column;
                            box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                        -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                            .box_head {
                                position: relative;
                                width: 100%;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                margin-left: 5px;
                                padding-left: 15px;
                                padding-right: 5px;

                                &::before {
                                    content: '';
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 3px;
                                    height: 100%;
                                    background: ${colors.customColors.blueColor2};
                                    border-radius: 25px;
                                }

                                h3 {
                                    position: relative;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor};
                                    font-style: italic;
                                }

                                a {
                                    position: relative;
                                    padding: 4px 15px;
                                    font-size: 11px;
                                    font-weight: 500;
                                    background: ${colors.customColors.greenColorLight};
                                    color: ${colors.customColors.greenColor};
                                    border-radius: 25px;
                                    cursor: pointer;
                                    margin-left: auto;

                                    i {
                                        position: relative;
                                        margin-right: 5px;
                                    }
                                }
                            }

                            .box_bottom {
                                position: relative;
                                width: 100%;
                                margin-top: 15px;
                                display: flex;
                                
                                &.academics {
                                    flex-wrap: wrap;

                                    li {
                                        position: relative;
                                        list-style: none;
                                        display: flex;
                                        align-items: center;
                                        border: 1px solid ${colors.customColors.borderColor};
                                        box-shadow: 0 0 4px ${colors.boxShadowColors.shadowColor1};
                                        background: ${colors.customColors.whiteColor};
                                        margin: 5px;
                                        padding: 5px 10px;
                                        border-radius: 5px;

                                        span {
                                            position: relative;
                                            font-size: 12px;
                                            font-weight: 500;
                                            color: ${colors.customColors.blackColor1};
                                        }

                                        p {
                                            position: relative;
                                            margin-left: 5px;
                                            font-size: 12px;
                                            color: ${colors.customColors.blackColor2};
                                        }
                                    }
                                }

                                &.fees {
                                    flex-direction: column;

                                    li {
                                        position: relative;
                                        list-style: none;
                                        display: flex;
                                        align-items: center;
                                        padding: 0 10px;
                                        margin-top: 5px;

                                        &:first-of-type {
                                            margin-top: 0;
                                        }

                                        span {
                                            position: relative;
                                            font-size: 13px;
                                            color: ${colors.customColors.blackColor1};
                                            font-weight: 500;
                                        }

                                        p {
                                            position: relative;
                                            margin-left: 6px;
                                            font-size: 13px;
                                            color: ${colors.customColors.blackColor2};
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .installment_box {
                        position: relative;
                        width: 40%;
                        padding: 10px;

                        .box_inner {
                            position: relative;
                            width: 100%;
                            height: 100%;
                            padding: 15px;
                            background: ${colors.customColors.whiteColor};
                            border: 1px solid ${colors.customColors.borderColor};
                            border-radius: 8px;
                            display: flex;
                            flex-direction: column;
                            box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                        -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                            .box_head {
                                position: relative;
                                width: 100%;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                margin-left: 5px;
                                padding-left: 15px;
                                padding-right: 5px;

                                &::before {
                                    content: '';
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 3px;
                                    height: 100%;
                                    background: ${colors.customColors.blueColor2};
                                    border-radius: 25px;
                                }

                                h3 {
                                    position: relative;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor};
                                    font-style: italic;
                                }

                                a {
                                    position: relative;
                                    padding: 4px 15px;
                                    font-size: 11px;
                                    font-weight: 500;
                                    background: ${colors.customColors.greenColorLight};
                                    color: ${colors.customColors.greenColor};
                                    border-radius: 25px;
                                    cursor: pointer;
                                    margin-left: auto;

                                    i {
                                        position: relative;
                                        margin-right: 5px;
                                    }
                                }
                            }

                            .box_bottom {
                                position: relative;
                                width: 100%;
                                margin-top: 15px;
                                padding: 0 5px;

                                table {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-direction: column;

                                    thead {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        padding: 0 10px;
                                        padding-bottom: 3px;
                                        border-bottom: 1px solid ${colors.customColors.blackColor2};

                                        tr {
                                            position: relative;
                                            width: 100%;
                                            display: flex;
                                        }

                                        th {
                                            position: relative;
                                            font-size: 13px;
                                            font-weight: 500;
                                            font-style: italic;
                                            display: flex;
                                            color: ${colors.customColors.blackColor};

                                            &:nth-of-type(1) {
                                                width: 25%;
                                                justify-content: flex-start;
                                            }

                                            &:nth-of-type(2) {
                                                width: 50%;
                                                justify-content: center;
                                            }

                                            &:nth-of-type(3) {
                                                width: 25%;
                                                justify-content: flex-end;
                                            }
                                        }
                                    }

                                    tbody {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        flex-direction: column;

                                        tr {
                                            position: relative;
                                            width: 100%;
                                            padding: 7px 10px;
                                            display: flex;

                                            &:nth-of-type(even) {
                                                background: ${colors.customColors.lightBackground3};
                                            }

                                            td {
                                                position: relative;
                                                font-size: 13px;
                                                display: flex;
                                                color: ${colors.customColors.blackColor1};

                                                &:nth-of-type(1) {
                                                    width: 25%;
                                                    font-style: italic;
                                                    color: ${colors.customColors.blackColor};
                                                }

                                                &:nth-of-type(2) {
                                                    width: 50%;
                                                    justify-content: center;
                                                }

                                                &:nth-of-type(3) {
                                                    width: 25%;
                                                    justify-content: flex-end;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .payment_brief_sec {
                    position: relative;
                    width: 100%;
                    margin-top: 15px;
                    padding: 0 15px;
                    padding-top: 10px;
                    display: flex;
                    justify-content: flex-end;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 10px;
                        width: calc(100% - 20px);
                        height: 1px;
                        background: linear-gradient(to left, ${colors.customColors.borderColor1}, ${colors.customColors.whiteColor});
                    }

                    .sec_inner {
                        position: relative;
                        width: 400px;
                        display: flex;
                        flex-direction: column;

                        .payment_row {
                            position: relative;
                            width: 100%;
                            display: flex;
                            flex-direction: column;

                            li {
                                list-style: none;
                                position: relative;
                                width: 100%;
                                display: flex;
                                margin-top: 8px;
                                justify-content: space-between;

                                span {
                                    font-size: 14px;
                                    color: ${colors.customColors.blackColor};
                                }

                                p {
                                    font-size: 16px;
                                    color: ${colors.customColors.blackColor1};
                                }
                            }
                        }

                        .payment_total {
                            position: relative;
                            width: 100%;
                            margin-top: 10px;
                            border-top: 1px solid ${colors.customColors.borderColor};
                            padding-top: 10px;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;

                            li {
                                position: relative;
                                list-style: none;
                                display: flex;
                                flex-direction: column;

                                span {
                                    position: relative;
                                    font-size: 11px;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor2};
                                }

                                p {
                                    position: relative;
                                    font-size: 22px;
                                    font-weight: 600;
                                    line-height: 1;
                                    margin-top: 3px;
                                }
                            }

                            a {
                                position: relative;
                                display: flex;
                                align-items: center;
                                padding: 9px 25px 9px 18px;
                                background: ${colors.customColors.greenColorLight};
                                border-radius: 20px;

                                img {
                                    position: relative;
                                    width: 18px;
                                }

                                p {
                                    position: relative;
                                    font-size: 13px;
                                    font-weight: 500;
                                    margin-left: 8px;
                                    color: ${colors.customColors.greenColor1};
                                }
                            }
                        }
                    }
                }

                .btn_sec {
                    position: relative;
                    width: 100%;
                    margin-top: 50px;
                    padding:  0 15px;
                    display: flex;
                    justify-content: space-between;

                    button {
                        position: relative;
                        width: 150px;
                        height: 35px;
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        color: ${colors.customColors.whiteColor};
                        border: none;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.5s ease;

                        i {
                            margin-right: 6px;
                        }

                        &:hover {
                            border-radius: 25px;
                            transition: all 0.5s ease;
                        }

                        &:disabled {
                            opacity: 0.4;
                            cursor: not-allowed;
                            transition: all 0.5s ease;
                        }

                        &:first-of-type {
                            background: ${colors.customColors.blackColor3};
                        }

                        &:last-of-type {
                            background: ${colors.customColors.blueColor1};
                        }
                    }
                }
            }
        }
    }
`;

export const DiscountFineWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        margin-top: 10px;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .add_btn {
            position: relative;
            margin-left: auto;

            button {
                position: relative;
                height: 35px;
                padding: 0 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                border: none;
                color: ${colors.customColors.whiteColor};
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.5s ease;

                i {
                    margin-right: 8px;
                    font-size: 12px;
                }

                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .tab_sec {
        position: relative;
        margin-top: 25px;
        width: 100%;
        padding: 0 15px;

        .tab_inner {
            position: relative;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${colors.themeColor};

            li {
                position: relative;
                list-style: none;
                height: 100%;
                padding: 0 20px;
                padding-top: 2px;
                display: flex;
                align-items: center;
                font-size: 12.5px;
                color: ${colors.customColors.blackColor1};
                border-radius: 6px 6px 0 0;
                cursor: pointer;
                transition: all 0.5s ease;
                
                &:hover {
                    color: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
                
                &.active {
                    color: ${colors.customColors.whiteColor};
                    background: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
            }
        }
    }
`;
